// extracted by mini-css-extract-plugin
export default {"faqsSectionLight":"FAQs_faqsSectionLight__opcZ8","faqsSectionDark":"FAQs_faqsSectionDark__vhkmH"};